import { faBug } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { usePermissions } from 'contexts/PermissionsContext';
import { useDebug } from 'shared/debug/debug_store';
import { MenuButton } from 'styles/theme_styles/button';
import { tokens } from 'styles/tokens';

export function DebugToggle() {
    const { isDebugMode, toggleIsDebugMode } = useDebug();
    const { canViewDebug } = usePermissions();

    return (
        <>
            {canViewDebug && (
                <MenuButton onClick={toggleIsDebugMode} title="Toggle debug mode (alt+g)">
                    <FontAwesomeIcon
                        icon={faBug}
                        // Override the menu button color to show warning when debug mode is active
                        color={isDebugMode ? tokens.warning.default : undefined}
                    />
                </MenuButton>
            )}
        </>
    );
}
